export default __webpack_public_path__ + "static/media/icon_linkedin.710e6db4.svg";